import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { Box, Typography, CardActions } from "@mui/material";
import Card from '@mui/material/Card';

import CardContent from '@mui/material/CardContent';

import { makeStyles } from "@mui/styles";


import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';

import AuthenticatorSetupContent from "../UserDetails/AccountSettingsModal/SecurityTab/AuthenticatorSetupContent";
import ActionStrip from "../UserDetails/AccountSettingsModal/SecurityTab/ActionStrip";
import useAuthenticatorSetup from "../../hooks/MFA/useAuthenticatorSetup";

import { useSnackbar } from "../../hooks";


import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { setLocale } from "../../actions";
import LanguageSwitcher from "../layouts/NavBar/NavbarLanguage";


const useStyles = makeStyles(theme => ({
  headTitle: {
    fontSize: 18,
    fontWeight: 600,
    marginBottom: "0px",
  },
  headSubTitle: {
    marginTop: "-2px",
    fontSize: 14,
    fontWeight: 400,
  },
  headSubTitleItalic: {
    marginTop: "-2px",
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'italic',
  },
  headMarginBottom: {
    marginBottom: "10px",
  }
}));

const ForceMFASetup = ({
  allowAbort = false,
  onAbort,
  onMfaSetupComplete,
  username,
  locale,
  setLocale
}) => {

  const snackbar = useSnackbar();
  const classes = useStyles();
  const intl = useIntl();

  const [activeStep, setActiveStep] = useState(0);

  const { secret,
    loading,
    verifyloading,
    updateLoading,
    verifyResult,
    updateResult,
    verifyError,
    updateError,
    handleVerifySecret,
    handleUpdateSecret, } = useAuthenticatorSetup();

  const [otp, setOtp] = useState("");

  useEffect(() => {

    if (verifyResult) {
      setActiveStep(2);
    }

  }, [verifyResult]);

  useEffect(() => {

    if (updateResult) {
      snackbar.success(intl.formatMessage({ id: "users.security.forcemfa.success" }));
      onMfaSetupComplete();
    }

  }, [updateResult])

  const handleComplete = () => {
    handleUpdateSecret();
  };

  const handleAbort = () => {
    setActiveStep(0);
    onAbort?.();
  };

  const handleVerify = () => {
    handleVerifySecret(otp);
  };

  return (
    <>
      <Box className={classes.headMarginBottom} xs={2}>
        <LanguageSwitcher locale={locale} setLocale={setLocale} />
        <Typography className={classes.headTitle}><FormattedMessage id="users.security.forcemfa.verifytitle" /></Typography>
        <Typography className={classes.headSubTitle}><FormattedMessage id="users.security.forcemfa.verifysubtitle" /></Typography>
      </Box>
      <Card>
        <CardContent>
          <AuthenticatorSetupContent
            activeStep={activeStep}
            username={username}
            secret={secret}
            otp={otp}
            onOtpChange={setOtp}
            onVerify={handleVerify}
          />
        </CardContent>
        <CardActions sx={{ justifyContent: "flex-end", padding: "16px 32px 16px 16px"}}>
          <ActionStrip
            allowAbort={allowAbort}
            onAbort={handleAbort}
            onComplete={handleComplete}
            onVerify={handleVerify}
            activeStep={activeStep}
            verifyloading={verifyloading}
            onSetActiveStep={setActiveStep} />
        </CardActions>
      </Card>

      <Alert severity="info" sx={{ marginTop: "20px" }}>
        <AlertTitle><FormattedMessage id="users.security.forcemfa.alert.title" /></AlertTitle>
        <Typography>UniQueue Support</Typography>
        <Typography>E-post: support@mikasverige.se</Typography>
      </Alert>
    </>
  );
};

const mapStateToProps = state => ({
  locale: state.ui.locale,
});

const mapDispatchToProps = dispatch => bindActionCreators({ setLocale }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ForceMFASetup);
